import React from 'react';
import EcoImg from 'eco-design/base/eco-img';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

const UsageScenariosA = () => {
    const { t } = useLang('Delta3MaxSeriesStation.UsageScenariosA');
    return (
        <section className={`${styles.UsageScenariosA} GtmModuleData-section`} id="UsageScenariosA" data-section-id={'UsageScenariosA'}>
            <EcoImg
                isOpenLazy
                pc="https://websiteoss.ecoflow.com/upload/image/1762224038045/Frame%202094654336.jpg"
                pad="https://websiteoss.ecoflow.com/upload/image/1762224033787/m-22.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1762224033787/m-22.jpg"
                className="usage-banner"
            />
            <div className="sub-text">
                <p className="title">{t('title')}</p>
                <p className="sub-title">{t('subTitle')}</p>
            </div>
        </section>
    );
};

export default UsageScenariosA;
